import Vue from 'vue'
import moment from 'moment'
import Vuetify from 'vuetify/lib'
import VueCookie from 'vue-cookie'
import 'vuetify/src/stylus/app.styl'
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)

Vue.use(VueCookie);

Vue.use(Vuetify, {
  iconfont: 'md',
  options: {
    customProperties: true,
  },
  theme: {
    primary: '#3892C7',
    secondary: '#404040',
    accent: '#004b8a',
    background: '#FFF',
  }
})

Vue.filter('formatDate', function(value) {
  if (value) {
    var date = new Date(String(value))
    if (isNaN(date)) {
      return
    }
    return moment(new Date(String(value))).format('DD/MM/YYYY')
  }
});
